import * as React from 'react';
import { connect } from 'react-redux';
import * as  apiService from '../../store/apiService'

// logout
import { logout } from '../../store/login/action'

// header
import Header from '../../sharedcomponents/header';

// loading
import { Loader } from '../../sharedcomponents/loader';

import { Link } from 'react-router-dom';

// actions
import { fetchAllOpenModsReport } from '../../store/openModsReport/actions'
import ModReportsGrid from './modsReportGrid';
import { modReportsColumns } from './modReportsColumn'

class openModeReport extends React.PureComponent<any, any>  {
  public changeCurrentPage: any; public changePageSize: any;

  constructor(props: any) {
    super(props);

    this.state = {
      openModsGrid: true,
      modQuotesGrid: false,
      openModsRows: [],
      openModsColumns: modReportsColumns.columnsOpenMods,
      modQuotesrows: [],
      modQuotesColumns: modReportsColumns.columnsModsQuotes
    };
    this.Sessionlogout = this.Sessionlogout.bind(this);
  }
  

  public componentWillMount() {
    this.props.dispatch(fetchAllOpenModsReport())
  }

  public componentDidMount() {
    this.props.dispatch(fetchAllOpenModsReport());
  }


  public Sessionlogout() {
    this.props.dispatch(logout());
  }

  public handleClickRowEdit(args: any) {
    window.open(apiService.atlaslink(args), "_blank")
  }

  public componentDidUpdate() {
    if (this.props.AllReports) {
      this.setState({
        openModsRows: this.props.AllReports.openModeData,
        modQuotesrows: this.props.AllReports.modQuotesData
      })
    }
  }

  public commitChanges(deleted: any) {
    console.log(deleted);
    let { rows } = this.state;
    if (deleted) {
      const deletedSet = new Set(deleted);
      rows = rows.filter((row: any) => !deletedSet.has(row.id));
      console.log(rows);
    }
    this.setState({ rows });
  }

  public changeSorting(sorting: any) {
    this.setState({
      loading: true,
      sorting
    });
  }

  public changeSortingModQuotes(sortingModQuotes: any) {
    this.setState({
      loading: true,
      sortingModQuotes
    })
  }

  public render() {
    const { path } = this.props.match;
    const loading = this.props.loading ? <Loader /> : '';
 
    return (

      <div>
        {loading}
        <Header />
        <div className="header-bottom">
          <button
            className="btn right-float"
            onClick={() => this.Sessionlogout()}
          >Logout</button>
        </div>
        <div className="content-body">
          <div className="production-filter">
            <ul>
              <li
                className={this.state.openModsGrid ? 'active' : ''}
                onClick={
                  (e) => {
                    const gridStatus = this.state.openModsGrid ? false : true
                  
                    this.setState({ openModsGrid: gridStatus});
                  }} >
                <Link to={`${path}`}>
                  Open Mods
                </Link>
              </li>
              <li
                className={this.state.modQuotesGrid ? 'active' : ''}
                onClick={
                  (e) => {
                    const gridStatus = this.state.modQuotesGrid ? false : true
                   
                    this.setState({ modQuotesGrid: gridStatus});
                  }} >
                <Link to={`${path}`}>
                  Mod Quotes
                </Link>
              </li>
            </ul>
            <div className="clear"></div>
          </div>
          <div className="content-section" id="open_mods_report">
            <div className="grid-style">

            {
              this.state.openModsGrid ? (
                  <ModReportsGrid
                    rows={this.state.openModsRows || []}
                    columns={this.state.openModsColumns}
                  />
              ) : ""
            }

            {
              this.state.modQuotesGrid ? (
                  <ModReportsGrid
                    rows={this.state.modQuotesrows || []}
                    columns={this.state.modQuotesColumns}
                  />
              ) : ""
            }
            
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// container
const mapStateToProps = (state: any) => ({
  AllReports: state.openModsReport.AllReports,
  loading: state.loading.getopenModsReportStatus
});
export default connect(mapStateToProps)(openModeReport);


// WEBPACK FOOTER //
// ./src/components/Open Mods/openModsReport.tsx